
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CreateInstantConversationRequest,
  FinalizeDraftInstantConversationRequest,
  InstantConversationUsageResponse,
} from '../models';
import {
    CreateInstantConversationRequestFromJSON,
    CreateInstantConversationRequestToJSON,
    FinalizeDraftInstantConversationRequestFromJSON,
    FinalizeDraftInstantConversationRequestToJSON,
    InstantConversationUsageResponseFromJSON,
    InstantConversationUsageResponseToJSON,
} from '../models';

export interface CreateInstantConversationOperationRequest {
    createInstantConversationRequest: CreateInstantConversationRequest;
}

export interface FinalizeDraftInstantConversationOperationRequest {
    finalizeDraftInstantConversationRequest: FinalizeDraftInstantConversationRequest;
}

/**
 * 
 */
export class InstantConversationApi extends runtime.BaseAPI {

    /**
     * Create an instant conversation between freelancer and client 
     * Create an instant conversation between freelancer and client
          */
    async createInstantConversationRaw(requestParameters: CreateInstantConversationOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<string>> {
        if (requestParameters['createInstantConversationRequest'] == null) {
            throw new runtime.RequiredError(
                'createInstantConversationRequest',
                'Required parameter "createInstantConversationRequest" was null or undefined when calling createInstantConversation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<string>({
            path: `/profile/api/client/conversation/instant`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateInstantConversationRequestToJSON(requestParameters['createInstantConversationRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Create an instant conversation between freelancer and client 
     * Create an instant conversation between freelancer and client
          */
    async createInstantConversation(requestParameters: CreateInstantConversationOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.createInstantConversationRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Finalize a draft instant conversation between freelancer and client 
     * Finalize a draft instant conversation between freelancer and client
          */
    async finalizeDraftInstantConversationRaw(requestParameters: FinalizeDraftInstantConversationOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<string>> {
        if (requestParameters['finalizeDraftInstantConversationRequest'] == null) {
            throw new runtime.RequiredError(
                'finalizeDraftInstantConversationRequest',
                'Required parameter "finalizeDraftInstantConversationRequest" was null or undefined when calling finalizeDraftInstantConversation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<string>({
            path: `/profile/api/client/conversation/instant/finalize-draft`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FinalizeDraftInstantConversationRequestToJSON(requestParameters['finalizeDraftInstantConversationRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Finalize a draft instant conversation between freelancer and client 
     * Finalize a draft instant conversation between freelancer and client
          */
    async finalizeDraftInstantConversation(requestParameters: FinalizeDraftInstantConversationOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.finalizeDraftInstantConversationRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Returns the instant conversation current usage for a client 
     * Returns the instant conversation current usage for a client
          */
    async getInstantConversationUsageForUserRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<InstantConversationUsageResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<InstantConversationUsageResponse>({
            path: `/profile/api/client/conversation/instant/usage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=InstantConversationUsageResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Returns the instant conversation current usage for a client 
     * Returns the instant conversation current usage for a client
          */
    async getInstantConversationUsageForUser(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<InstantConversationUsageResponse> {
        const response = await this.getInstantConversationUsageForUserRaw(initOverrides);
        return response._data;
    }

}
